<template>
  <div class="row">
    <div class="col-12">
      <div class="pane-header">
        <span class="icon"><icon-colored-daypart /></span>
        <span>{{ capitalize($t('names.daypart', { n: 1 })) }}</span>
      </div>
    </div>
    <div class="col-12">
      <div class="pane-content pad-top">
        <div class="row">
          <div class="col-12">
            <span id="package_details_daypart">
              <span
                v-show="props.deal.isDaypartEmpty"
                class="text-muted"
                >{{ $t('messages.noSelection') }}</span
              >
              <span
                v-show="props.deal.isDaypartFull"
                class="text-muted"
                >{{ $t('messages.allHoursOfTheDayAllWeek') }}</span
              >
            </span>

            <daypart-viewer
              v-if="props.deal.daypart && !props.deal.isDaypartEmptyOrFull"
              :daypart="props.deal.daypart" />

            <input
              id="package_details_daypart_value"
              aria-hidden="true"
              type="hidden"
              :value="props.deal.daypart" />
            <input
              id="package_details_daypart_overridable_value"
              aria-hidden="true"
              type="hidden"
              :value="props.deal.daypartOverridable" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize } from 'vue';

  import { DaypartViewer } from '@/common/components/controls';
  import { IconColoredDaypart } from '@/common/icons/colored';
  import { Package } from '@/common/models';

  interface IDealDetailsDaypartProps {
    deal: Package;
  }

  const props = defineProps<IDealDetailsDaypartProps>();
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;
</style>
